import { RestMethod } from "../../_helpers/ApiConfig/RestMethod";

export async function getAllEvents(filter) {
  let url = "/global-configuration/ehs-module/all-events?";

  if (filter) url += filter;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function getAllEventsRoHoMine(filter) {
    let url = "/global-configuration/ehs-module//all-events-ro-ho-mine?";

    if (filter) url += filter;

    try {
        const response = await RestMethod.GET(url);
        return response.data;
    } catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

export async function createEvent(data) {
  try {
    const response = await RestMethod.POST(
      "/global-configuration/ehs-module/create-event",
      data
    );
    console.log(response.data, "data");
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function updateEvent(id, data) {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/update-event/" + id,
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function deleteEvent(id) {
  try {
    const response = await RestMethod.DELETE(
      "/global-configuration/ehs-module/delete-event/" + id
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
